import script from "./DashboardPersons.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPersons.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPersons.vue?vue&type=style&index=0&id=6c456464&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c456464"]])

export default __exports__